import safeStringify from "fast-safe-stringify";
import { createLogger } from "./createLogger";
import { getTime } from "./time";
import Constants from "@/constants";
import { HUYASdk } from "@huyafed/huya-kiwi";
import { env } from "@/config/env";

const timestamp = Date.now();

function safetyStringify(v: any) {
  try {
    return safeStringify(v);
  } catch (error) {
    return "";
  }
}

const logger = createLogger({
  onAfter(logInfo) {
    HUYASdk.log(logInfo.desc + " " + safetyStringify(logInfo.data));
  },
  prefix() {
    return `team-fight-tactics-trend * date:${getTime()} uid:${env.uid} sessionId:${timestamp} -`;
  },
  enableLog() {
    if (Constants.IS_DEBUG || Constants.LOGGER_DEV) return true;
    return false;
  },
});

export default logger;
